import { Col, Divider, Row } from "antd"
import { Header } from "antd/lib/layout/layout"
import { FC } from "react"
import { obtenerIcono } from "../util/AppIcons"
import useWindowDimensions from "../util/windows-dimension-hooks"
import { InputSearch } from "./InputSearch"
import { CustomMenu } from "./Menu"
import { LayoutSize } from './../util/LayoutSize';


export const CustomHeader: FC<{showDrawer:CallableFunction , open:boolean}> = (props) => {


  const isMobile = useWindowDimensions().width <= LayoutSize.lg


  const handleClick = () => {
    window.location.href = "/"
  }

  const handleClickLogin = () => {
    window.location.href = "/login"
  }

  const _styleHeader: React.CSSProperties = {
    border: "1px solid #DBDBDB;",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)",
    position: 'fixed',
    zIndex: 100,
    width: '100%',
    height: !isMobile ? "76px" : "56px",
    background: "#FFFFFF",
    
  }

  
  const customDivider = () => {
    return (
      <Divider type="vertical" style={{ height: "55px", color: "#DBDBDB", background: "#DBDBDB" }} />
    )
  }


  return (
    <>
      <Header className="header-shadow" style={_styleHeader}>
        {
          !isMobile ?
            <>

              <Row  justify="space-between">
                <Col xxl={3} xl={3} lg={4} style={{ paddingLeft: "2.6%" }} className='logo' onClick={handleClick}>
                  {
                    obtenerIcono("logo-autopia")
                  }</Col>
                <Col xxl={9} xl={9} lg={8}style={{ paddingLeft: "3%" }} >
                  <InputSearch isMobile={isMobile}></InputSearch>
                </Col>
                <Col xxl={9} xl={10} lg={8}style={{ paddingLeft: "5%" }} >
                  <CustomMenu ></CustomMenu>
                 
                </Col>
                <Col xxl={3} xl={2} lg={4}  onClick={handleClickLogin}>

                  {
                    obtenerIcono("login")
                  }
             



                </Col>

              </Row>
            </>
            :
            <>

              <Row justify='center'>
                <Col span={3} style={{marginRight:"5px"}} onClick={handleClick}>
                  {
                    obtenerIcono("logo-autopia-mobile")
                  }

                </Col>
                {customDivider()}
                <Col span={14}>
                  <InputSearch isMobile={isMobile}></InputSearch>
                </Col>
                
                {customDivider()}
                
                <Col span={1} style={{marginRight:"52px" }}  onClick={() => props.showDrawer(props.open)}>

                  {
                    obtenerIcono(props.open ? "close-menu": "menu-hamburguesa-open")
                  }
                </Col>

              </Row>
            </>
        }

      </Header>
    </>
  )
}